import { render, staticRenderFns } from "./UserAddress.vue?vue&type=template&id=17f010d8&"
import script from "./UserAddress.vue?vue&type=script&lang=js&"
export * from "./UserAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports